import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from '../../../components/form/form.component';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { createHour, updateHour } from '../../../redux/thunks/admin/hours';
import { newHourForm_admin } from '../../../utils/form-configs/hours.form';

const HourModal = ({ show, onClose, hour }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isCreating, isUpdating } = useSelector(
    (state) => state.entities.admin.hours
  );
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: hour
      ? {
          projectId: [hour.project],
          userId: [hour.user],
          startedAt: hour.startedAt,
          finishedAt: hour.finishedAt,
          date: new Date(hour.date).toISOString().split('T')[0],
          totalTime: hour.totalTime,
          hourlyRate: hour.hourlyRate || '',
          monthlyRate: hour.monthlyRate || '',
          notes: hour.notes,
        }
      : {},
  });

  useEffect(() => {
    watch(() => clearErrors('invalid'));
  }, [watch, clearErrors]);

  const onSubmit = (formData) => {
    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      onClose();
    };
    const onFailure = (message) =>
      enqueueSnackbar(message, { variant: 'error' });

    if (
      (typeof formData.hourlyRate === 'string' &&
        !formData.hourlyRate.length) ||
      (typeof formData.hourlyRate === 'number' &&
        Number(formData.hourlyRate) <= 0)
    ) {
      delete formData.hourlyRate;
    }

    if (
      (typeof formData.monthlyRate === 'string' &&
        !formData.monthlyRate.length) ||
      (typeof formData.monthlyRate === 'number' &&
        Number(formData.monthlyRate) <= 0)
    ) {
      delete formData.monthlyRate;
    }

    if (!hour) {
      dispatch(
        createHour({
          formData: {
            ...formData,
            projectId: formData.projectId[0],
            userId: formData.userId[0],
          },
          onSuccess,
          onFailure,
        })
      );
    } else {
      dispatch(
        updateHour({
          formData: {
            _id: hour._id,
            ...formData,
            projectId: formData.projectId[0]._id,
            userId: formData.userId[0]._id,
          },
          onSuccess,
          onFailure,
        })
      );
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{hour ? 'Edit' : 'Add'} Hour</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={newHourForm_admin}
          useForm={{
            register,
            errors,
            setValue,
            getValues,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
        <Button
          variant='primary'
          onClick={handleSubmit(onSubmit)}
          disabled={!hour ? isCreating : isUpdating[hour._id]}
        >
          {hour ? 'Edit' : 'Add'} Hour
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HourModal;
